"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isOrderOnBehalfVisible,
  theme,
  onClick
}) => ({
  background: isOrderOnBehalfVisible ? theme.palette.blue[300] : theme.palette.primary.light,
  color: isOrderOnBehalfVisible ? theme.palette.common.white : theme.palette.text.primary,
  cursor: onClick ? 'pointer' : 'default',
  display: 'flex',
  zIndex: theme.zIndex.appBar,
  height: _constants.TOP_AREA_BANNER_HEIGHT,
  width: '100vw',
  position: 'fixed',
  top: '0',
  left: '0',
  alignItems: 'center',
  justifyContent: 'center'
}));